import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import service from '@/utils/request';
export var getChannelList = function getChannelList(data) {
  return service({
    url: "/channel/getChannelList",
    method: 'post',
    data: data
  });
};

// @Summary 获取渠道权限
// @Produce  application/json
// @Param {
//  page     int
//	pageSize int
// }
// @Router /app/appList [post]
export var getChannelAuth = function getChannelAuth(data) {
  return service({
    url: "/channel/getChannelAuth",
    method: 'post',
    data: data
  });
};

// @Summary 保存渠道权限
// @Produce  application/json
// @Param {
//  page     int
//	pageSize int
// }
// @Router /app/appList [post]
export var saveChannelAuth = function saveChannelAuth(data) {
  return service({
    url: "/channel/saveChannelAuth",
    method: 'post',
    data: data
  });
};
var availableServerList = null;
// 根据渠道权限获取服务器列表（列表已排序-根据渠道和开服时间排序）
export var getAvailableServerList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var result;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(availableServerList == null)) {
            _context.next = 5;
            break;
          }
          _context.next = 3;
          return service({
            url: "/channel/getAvailableServerList",
            method: 'post'
          });
        case 3:
          result = _context.sent;
          if (result.code == 0) {
            availableServerList = [];
            result.data.forEach(function (item) {
              availableServerList.push({
                id: item.serverId,
                label: item.serverName
              });
            });
          }
        case 5:
          return _context.abrupt("return", availableServerList);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getAvailableServerList() {
    return _ref.apply(this, arguments);
  };
}();
var availableChannelList = null;
export var getAvailableChannelList = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var result;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(availableChannelList == null)) {
            _context2.next = 5;
            break;
          }
          _context2.next = 3;
          return service({
            url: "/channel/getAvailableChannelList",
            method: 'post'
          });
        case 3:
          result = _context2.sent;
          if (result.code == 0) {
            availableChannelList = [];
            result.data.forEach(function (item) {
              availableChannelList.push({
                id: item.channel_id,
                label: item.channel_name
              });
            });
          }
        case 5:
          return _context2.abrupt("return", availableChannelList);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getAvailableChannelList() {
    return _ref2.apply(this, arguments);
  };
}();
export var getChannelListWithPage = function getChannelListWithPage(data) {
  return service({
    url: "/channel/getChannelListWithPage",
    method: 'post',
    data: data
  });
};
export var createChannel = function createChannel(data) {
  return service({
    url: "/channel/createChannel",
    method: 'post',
    data: data
  });
};
export var updateChannel = function updateChannel(data) {
  return service({
    url: "/channel/updateChannel",
    method: 'post',
    data: data
  });
};